import { render, staticRenderFns } from "./CsTabs.vue?vue&type=template&id=474e6e3c&"
import script from "./CsTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsTabs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports